import { HomeOutlined, WifiOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useWsStatusMonitor } from '../../api/ws';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import { playSound } from '@/utils/sound';
import { Brand_Logo, getAdminAvatar } from '@/utils/uiHelper';
import ButtonWithoutFocus from '../ButtonWithoutFocus';
import styles from './style.less';

const { Header } = Layout;

export const POS_Header_Height = 48;

const LayoutPosHeader: React.FC = ({}): React.ReactElement => {
  const navigate = useNavigate();
  const location = useLocation();

  // ws 连接
  const { connected: wsConnected, delay: wsPing } = useWsStatusMonitor();
  const [baseInfo] = useContext(BaseInfoContext);

  return (
    <Header className={`site-layout-background ${styles.header}`} style={{ padding: 0 }}>
      <div className={styles.brand}>
        <img alt={'veeyung pos'} src={Brand_Logo} draggable={false} />
        <h1>Veeyung POS</h1>
        <span className={`${styles.network} ${wsConnected ? styles.success : styles.error}`}>
          <WifiOutlined /> <span>{wsConnected ? wsPing || '-' : '-'}ms</span>
        </span>
      </div>
      <div className={styles.login}>
        <span className={styles.user}>
          <span className={styles.avatar}>
            {getAdminAvatar(baseInfo.avatar, baseInfo.assetsPrefix, { size: 28 })}
          </span>
          {baseInfo.userName}
        </span>

        <span
          className={styles.homeBtn}
          onClick={() => {
            if (location.pathname !== `/POS/index`) {
              navigate(`/POS/index`);
            }
            playSound('flip');
          }}>
          <ButtonWithoutFocus shape={'circle'} icon={<HomeOutlined />} ghost />
        </span>
      </div>
    </Header>
  );
};

export default LayoutPosHeader;
